import { Routes, Route, Navigate } from 'react-router-dom';
import { PageLayout } from './components/layout/PageLayout';
import { PasswordGate } from './components/PasswordGate';
import { PreferencesProvider } from './contexts';
import { MarketsPage } from './pages/MarketsPage';
import { InvestmentPropertiesPage } from './pages/InvestmentPropertiesPage';
import { PersonalScorerPage } from './pages/PersonalScorerPage';
import { WholesalerPage } from './pages/WholesalerPage';
import { CrawlPage } from './pages/CrawlPage';
import { RentalsPage } from './pages/RentalsPage';
import { AdminPage } from './pages/AdminPage';
import { MarketAnalysisPage } from './pages/MarketAnalysisPage';

function App() {
  return (
    <PasswordGate>
      <PreferencesProvider>
        <PageLayout>
          <Routes>
            <Route path="/" element={<InvestmentPropertiesPage />} />
            <Route path="/properties" element={<InvestmentPropertiesPage />} />
            <Route path="/markets" element={<MarketsPage />} />
            <Route path="/personal" element={<PersonalScorerPage />} />
            <Route path="/wholesale" element={<WholesalerPage />} />
            <Route path="/crawl" element={<CrawlPage />} />
            <Route path="/history" element={<Navigate to="/crawl" replace />} />
            <Route path="/rentals" element={<RentalsPage />} />
            <Route path="/market-analysis" element={<MarketAnalysisPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </PageLayout>
      </PreferencesProvider>
    </PasswordGate>
  );
}

export default App;
